import { Component, signal, HostListener, effect } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MIN_SCREEN_WIDTH } from '@constants';

@Component({
  selector: 'app-viewport-guard',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './viewport-guard.component.html',
  styleUrl: './viewport-guard.component.scss'
})
export class ViewportGuardComponent {
  isTooSmall = signal(window.innerWidth < MIN_SCREEN_WIDTH);

  constructor() {
    effect(() => {
      if (this.isTooSmall()) {
        window.scrollTo(0, 0);
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isTooSmall.set(window.innerWidth < MIN_SCREEN_WIDTH);
  }
}
